import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import filteredObjectsSelector from 'functions/filteredObjectsSelector'
import filterComparables from 'agency/digital_renderer/utils/filterComparables'

class ComparableWrapper extends React.Component {
  render(){
    const {
      campaignComparables, comparableSource, comparableStatus, render,
    } = this.props

    const comparables = filterComparables(campaignComparables, comparableSource, comparableStatus)

    if (!comparables.length) return null

    return render({
      comparables,
    })
  }
}

ComparableWrapper.propTypes = {
  campaignComparables: PropTypes.object.isRequired,
  comparableSource: PropTypes.string,
  comparableStatus: PropTypes.string,
  render: PropTypes.func.isRequired,
}

function mapStateToProps(state, props){
  const { campaign } = props

  return {
    campaignComparables: filteredObjectsSelector(state, 'campaignComparables', 'campaign_id', campaign.id),
  }
}

export default connect(mapStateToProps)(ComparableWrapper)
